import { CommonModule, formatNumber } from '@angular/common';
import { Component, computed, DestroyRef, effect, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import {
  AlertController,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { ICompanyDocument } from '@okcargo-apps/shared-domain-ionic';
import { AnalyticsService } from '@okcargo-apps/shared-infrastructure-ionic';
import { Observable } from 'rxjs';
import { FastpayInfoConditionsComponent } from '../fastpay-info-conditions/fastpay-info-conditions.component';

@Component({
  selector: 'lib-fastpay-request-modal',
  templateUrl: './fastpay-request-modal.component.html',
  styleUrls: ['./fastpay-request-modal.component.scss'],
  imports: [
    CommonModule,
    IonContent,
    IonCol,
    IonRow,
    IonGrid,
    IonFooter,
    IonTitle,
    IonIcon,
    IonButton,
    IonButtons,
    IonToolbar,
    IonHeader,
    TranslateModule,
    FastpayInfoConditionsComponent,
  ],
})
export class FastpayRequestModalComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);
  private readonly alertCtrl = inject(AlertController);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);

  private readonly destroyRef = inject(DestroyRef);

  public priceWithDiscount!: number;
  public freightId!: UUID;
  public hasEnoughDocs!: boolean;
  public expiredOrNotUploadedDocuments$!: Observable<ICompanyDocument[]>;

  private readonly expiredOrNotUploadedDocuments = signal<ICompanyDocument[]>([]);
  public readonly hasExpiredCompanyDocuments = computed(() => this.expiredOrNotUploadedDocuments().length > 0);

  readonly buttonText = computed(() =>
    !this.hasEnoughDocs
      ? this.translate.instant('fast_pay.upload_digitized_delivery_notes')
      : this.hasExpiredCompanyDocuments()
        ? this.translate.instant('fast_pay.manage_docs')
        : this.translate.instant('fast_pay.request_btn'),
  );

  constructor() {
    effect(() => {
      console.log('hasExpiredCompanyDocuments', this.hasExpiredCompanyDocuments());
    });
  }

  ngOnInit(): void {
    if (this.expiredOrNotUploadedDocuments$) {
      this.expiredOrNotUploadedDocuments$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((docs) => this.expiredOrNotUploadedDocuments.set(docs));
    }

    this.analyticsService.logPageView('fastpay-request-modal', {});
  }

  public async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public async closeModalWithAccept(): Promise<boolean> {
    if (!this.hasEnoughDocs) {
      await this.modalCtrl.dismiss(null, 'cancel');
      return false;
    }

    if (this.hasExpiredCompanyDocuments()) {
      await this.modalCtrl.dismiss(null, 'cancel');
      this.router.navigate(['/my-company']);
      return false;
    }

    const locale = this.translate.getCurrentLang();
    const priceWithDiscountFormatted = formatNumber(this.priceWithDiscount, locale, '1.2-2');

    const alert = await this.alertCtrl.create({
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant('fast_pay.confirm', { priceWithDiscount: priceWithDiscountFormatted }),
      buttons: [
        {
          text: this.translate.instant('general.cancel'),
          role: 'cancel',
          handler: () => {
            /* empty */
          },
        },
        {
          text: this.translate.instant('general.confirm'),
          role: 'confirm',
          handler: async () => {
            await this.modalCtrl.dismiss({ accepted: true }, 'confirm');
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    return role === 'confirm';

    // if (this.hasEnoughDocs && !this.hasExpiredCompanyDocuments()) {
    //   const locale = this.translate.getCurrentLang();
    //   const priceWithDiscountFormatted = formatNumber(this.priceWithDiscount, locale, '1.2-2');

    //   const alert = await this.alertCtrl.create({
    //     header: this.translate.instant('general.confirm'),
    //     message: this.translate.instant('fast_pay.confirm', { priceWithDiscount: priceWithDiscountFormatted }),
    //     buttons: [
    //       {
    //         text: this.translate.instant('general.cancel'),
    //         role: 'cancel',
    //         handler: () => {
    //           // do nothing
    //         },
    //       },
    //       {
    //         text: this.translate.instant('general.confirm'),
    //         role: 'confirm',
    //         handler: () => {
    //           this.modalCtrl.dismiss(null, 'confirm');
    //         },
    //       },
    //     ],
    //   });
    //   await alert.present();
    //   return false;
    // }

    // await this.modalCtrl.dismiss({ accepted: true }, 'confirm');

    // if (!this.hasEnoughDocs) {
    //   return this.modalCtrl.dismiss(null, 'cancel');
    // }

    // const route = this.hasExpiredCompanyDocuments() ? ['/my-company'] : [`/tabs/${AppTab.FINISHED}`];
    // this.router.navigate(route);
    // return true;
  }
}
